import { type FitViewOptions } from '@xyflow/react'
import { Transition } from 'framer-motion'

export const UNTITLED_AUTOMATION_NAME: string = 'Untitled'

// Shared fit-view config so the canvas's initial `fitView` and the manual
// re-centre button frame the workflow identically. Keep these in sync by
// importing this constant rather than redeclaring the options inline.
export const FIT_VIEW_OPTIONS: FitViewOptions = { maxZoom: 1 }

// Duration of the config form expand/collapse transition, shared by the panel
// height animation and the inner panel width transition so both dimensions
// animate together.
export const CONFIG_FORM_EXPAND_DURATION_SECONDS = 0.2

export const CONFIG_FORM_EXPAND_TRANSITION: Transition = {
  duration: CONFIG_FORM_EXPAND_DURATION_SECONDS,
  ease: 'easeInOut'
}

// CSS transition for the inner panel's width. Animating the real `width`
// property (rather than a transform) lets the content reflow instead of
// stretching, avoiding the smearing artifacts a scaled layout animation
// produces.
export const CONFIG_FORM_EXPAND_WIDTH_TRANSITION = `width ${CONFIG_FORM_EXPAND_DURATION_SECONDS}s ease-in-out`

// Duration of a canvas node's expand/collapse transition. A single
// framer-motion animation of this duration drives both the node's size lerp and
// the gap-preserving repositioning of its neighbours, so the two stay in sync.
export const NODE_EXPAND_DURATION_SECONDS = 0.2

export const NODE_EXPAND_TRANSITION: Transition = {
  duration: NODE_EXPAND_DURATION_SECONDS,
  ease: 'easeInOut'
}

// Above this many nodes of the toggled type, the expand/collapse animation
// (which re-lays out every node each frame) is dropped in favour of snapping
// straight to the target state, keeping the toggle responsive on busy canvases.
export const MAX_ANIMATED_EXPANSION_NODES = 5
